import { Result } from "./result";
/**
 * Manage value and listeners
 */
export class Manager {
    constructor(result, valueEquals, lifecycle, debugInfo) {
        this.result = result;
        this.lifecycle = lifecycle;
        this.debugInfo = debugInfo;
        this.listeners = new Map();
        this.subscriptionId = 0;
        this.equals = Result.equal(valueEquals);
    }
    get() {
        return this.result;
    }
    /** Mark as changed */
    changed() {
        for (const listener of this.listeners.values()) {
            listener.changed(this.debugInfo);
        }
    }
    /** Mark as dirty */
    dirty() {
        for (const listener of this.listeners.values()) {
            listener.dirty(this.debugInfo);
        }
    }
    /** Subscribe */
    subscribe(listener) {
        if (!this.listeners.size) {
            this.lifecycle.activate();
        }
        const id = this.subscriptionId++;
        this.listeners.set(id, listener);
        return {
            unsubscribe: () => {
                this.listeners.delete(id);
                if (!this.listeners.size) {
                    this.lifecycle.deactivate();
                }
            },
        };
    }
    /** Set result */
    set(result) {
        if (this.equals(this.result, result)) {
            return;
        }
        this.result = result;
        if (this.listeners.size) {
            this.lifecycle.change();
        }
    }
}
//# sourceMappingURL=util.js.map